export enum MarketingEmailItemType {
    MenuItem,
    Advert
}